import { render, staticRenderFns } from "./InternationalPhoneNumber.vue?vue&type=template&id=8a09004a&"
import script from "./InternationalPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./InternationalPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports